import { render } from "./OfflineMessage.vue?vue&type=template&id=6052c703&scoped=true"
import script from "./OfflineMessage.vue?vue&type=script&lang=js"
export * from "./OfflineMessage.vue?vue&type=script&lang=js"

import "./OfflineMessage.vue?vue&type=style&index=0&id=6052c703&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6052c703"

export default script